export class EnumDistribution {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "distinctBaseline",
            "baseName": "distinctBaseline",
            "type": "number",
            "format": ""
        },
        {
            "name": "distinctCurrent",
            "baseName": "distinctCurrent",
            "type": "number",
            "format": ""
        },
        {
            "name": "categories",
            "baseName": "categories",
            "type": "Array<EnumCategoryShare>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnumDistribution.attributeTypeMap;
    }
    constructor() {
    }
}
